import { Button, Divider, Heading } from '@madpaws/design-system';
import getConfig from 'next/config';
import { useRouter } from 'next/router';

import styles from './404.module.css';

import type { FC } from 'react';

const { publicRuntimeConfig } = getConfig();

export const NotFound: FC = () => {
  const router = useRouter();

  return (
    <>
      <div className={styles.root}>
        <img alt="404 page header" src={`${publicRuntimeConfig.staticPath}/images/jumping.svg`} />

        <Heading alignment="centerAlign" size="medium">
          Barking up the wrong tree?
        </Heading>
        <p>We can&apos;t find the page you&apos;re looking for.</p>

        <Button
          label="Go to homepage"
          onClick={(): void => {
            router.push('/');
          }}
        />
      </div>
      <Divider />
    </>
  );
};
